import ChatMessage from './ChatMessage';

class UserMessage extends ChatMessage {
  constructor(message = '') {
    super('user', message);
  }
}
export default UserMessage;
